module.exports = __webpack_public_path__ + "static/media/red03.694639e6.svg";